import { parseQuery } from './parseQuery';
import { gameLiveConnection } from '../services';
import { DefaultQueryParams } from '../constants/defaultQueryParams';

export const handleGamble = (event) => {
  const { [DefaultQueryParams.GameId]: gameId } = parseQuery(window.location.search);
  const gambleModel = {
    card: event.target.id,
    gameId: gameId,
  };

  gameLiveConnection.sendGamble(gambleModel);
};
